import * as actionTypes from "../ActionTypes";

const initialState = {
  exampleData: [],
  userData: [],
  usersData: [],
};

const store = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.TEST_INIT:
      return {
        ...state,
      };
    case actionTypes.TEST_SUCCESS:
      return {
        ...state,
        login: action.payload,
      };
    case actionTypes.TEST_FAIL:
      return {
        ...state,
        error: "",
      };
    case actionTypes.GET_USER_DATA:
      return {
        ...state,
        userData: action.payload,
      };

    case actionTypes.GET_USERS_DATA_INIT:
      return {
        ...state,
      };
    case actionTypes.GET_USERS_DATA_SUCCESS:
      return {
        ...state,
        usersData: action.payload,
      };
    case actionTypes.GET_USERS_DATA_FAIL:
      return {
        ...state,
        error: "",
      };
    default:
      return state;
  }
};

export default store;
